import React from "react";
import { classNames } from "../../shared/utility";

export default function Input(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    explanation,
    ref,
    labelClass,
    ...other
  } = props;

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="mb-1 flex space-x-2">
          <label
            htmlFor={name}
            className={classNames(
              labelClass ? labelClass : "text-sm",
              "block font-medium text-brand",
            )}
          >
            {label}
          </label>
        </div>
      ) : null}
      <div>
        <input
          type={type}
          name={name}
          id={name}
          className={className ? className : "input-brand mt-1"}
          value={value}
          onChange={onChange}
          ref={ref}
          {...other}
        />
        {error ? (
          <p className="mt-1 font-medium text-danger">{error}</p>
        ) : null}
        {explanation ? (
          <p className="mt-1 text-xs text-slate-500">{explanation}</p>
        ) : null}
      </div>
    </div>
  );
}
